import { Categoria } from "../DTO/Categoria";
import instance from "./axiosConfig";

export const useCategoriaStore = () => {
  const findAllCategorias = async () => {
    try {
      const response = await instance.get("/categorias");
      return response.data;
    } catch (error) {
      console.error("Error al obtener las categorias:", error);
      throw error;
    }
  };

    const createCategoria = async (nombre: string) => {
    try {
      const response = await instance.post("/categorias",{
        nombre
      });
      return response.data;
    } catch (error) {
      console.error("Error al crear la categoria:", error);
      throw error;
    }
  };

    const eliminarCategoria = async (id: number) => {
    try {
      const response = await instance.delete("/categorias/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al eliminar la categoria:", error);
      throw error;
    }
  };

    const obtenerCategoriabyId = async (id: string | null) => {
    try {
      const response = await instance.get("/categorias/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al obtener la categoria:", error);
      throw error;
    }
  };

    const editarCategoria = async (categoria: Categoria) => {
    try {
      const response = await instance.put("/categorias", categoria);
      return response.data;
    } catch (error) {
      console.error("Error al editar la categoria:", error);
      throw error;
    }
  };


  return {
    findAllCategorias,
    createCategoria,
    eliminarCategoria,
    obtenerCategoriabyId,
    editarCategoria
  };
};
